/**
 * Register actions
 */
export const FORGOT_USERNAME = 'FORGOT_USERNAME';
export const FORGOT_USERNAME_RESPONSE = 'FORGOT_USERNAME_RESPONSE';